// extracted by mini-css-extract-plugin
export default {"mrc":"f_mrc__8WPX8","title":"f_title__R5Wsw","sdglist":"f_sdglist__TX7rD","con":"f_con__Y65el"};